import React, { useState } from "react";
import { downloadDatabaseBackupAdmin } from "../services/adminDatabaseBackupService";

const AdminDatabaseBackup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const downloadBackup = async () => {
    console.log("[Backup][UI] Download triggered");

    setLoading(true);
    setError("");

    try {
      console.log("[Backup][UI] Calling adminDatabaseBackupService");

      const response = await downloadDatabaseBackupAdmin();

      console.log("[Backup][UI] Response received");
      console.log("[Backup][UI] Status:", response.status);
      console.log("[Backup][UI] Headers:", response.headers);

      // Extract filename from header
      const contentDisposition = response.headers["content-disposition"];
      console.log("[Backup][UI] Content-Disposition:", contentDisposition);

      let filename = "database_backup.sql";
      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match && match[1]) {
          filename = match[1];
        }
      }

      console.log("[Backup][UI] Download filename:", filename);
      console.log("[Backup][UI] Blob size:", response.data.size);

      // Create download
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      console.log("[Backup][UI] Download started successfully");
    } catch (err) {
      console.error("[Backup][UI] Error occurred:", err);

      if (err.response) {
        console.error(
          "[Backup][UI] Backend error:",
          err.response.status,
          err.response.data
        );
        setError(`Backup failed (status ${err.response.status})`);
      } else {
        setError("Failed to download database backup");
      }
    } finally {
      setLoading(false);
      console.log("[Backup][UI] Download process finished");
    }
  };

  return (
    <div style={styles.container}>
      <h2>Database Backup</h2>

      <p style={styles.info}>
        Click the button below to download the complete database backup.
      </p>

      <button
        onClick={downloadBackup}
        disabled={loading}
        style={{
          ...styles.button,
          backgroundColor: loading ? "#9ca3af" : "#2563eb",
        }}
      >
        {loading ? "Generating Backup..." : "Download Database Backup"}
      </button>

      {error && <p style={styles.error}>{error}</p>}
    </div>
  );
};

const styles = {
  container: {
    padding: "24px",
    maxWidth: "500px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  info: {
    marginBottom: "16px",
    color: "#555",
  },
  button: {
    padding: "12px 20px",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "16px",
  },
  error: {
    marginTop: "12px",
    color: "red",
  },
};

export default AdminDatabaseBackup;
